import { render, staticRenderFns } from "./DeliveryFounderConsultDetail.vue?vue&type=template&id=0857a4e2&"
import script from "./DeliveryFounderConsultDetail.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFounderConsultDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryFounderConsultDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports